const KANBAN_NATURAL_CONTENT_SELECTORS = [
  '.row-header',
  '.group-header',
  'affine-data-view-kanban-card',
  '.add-card',
  '.card-overflow',
].join(',');

const KANBAN_CONTENT_SELECTORS = [
  KANBAN_NATURAL_CONTENT_SELECTORS,
  '.row-body[data-row-key]',
  '.group-body',
  'affine-data-view-kanban-group',
].join(',');

export function measureKanbanRowsContentHeight({
  empty,
  rowsContainer,
  visualScale,
}: {
  empty: boolean;
  rowsContainer: HTMLElement;
  visualScale: number;
}): number {
  const containerRect = rowsContainer.getBoundingClientRect();
  let contentBottom = 0;
  const contentElements = rowsContainer.querySelectorAll<HTMLElement>(
    empty ? KANBAN_NATURAL_CONTENT_SELECTORS : KANBAN_CONTENT_SELECTORS
  );

  for (const element of Array.from(contentElements)) {
    const elementRect = element.getBoundingClientRect();
    if (elementRect.height <= 0) {
      continue;
    }
    const computedStyle = getComputedStyle(element);
    const marginBottom = Number.parseFloat(computedStyle.marginBottom) || 0;
    contentBottom = Math.max(
      contentBottom,
      (elementRect.bottom - containerRect.top) / visualScale + marginBottom
    );
  }

  if (empty) {
    return Math.max(KANBAN_GROUP_HEADER_HEIGHT, contentBottom);
  }

  let childBottom = 0;
  for (const child of Array.from(rowsContainer.children)) {
    if (!(child instanceof HTMLElement)) {
      continue;
    }
    childBottom = Math.max(
      childBottom,
      child.offsetTop + Math.max(child.scrollHeight, child.offsetHeight)
    );
  }
  return Math.max(contentBottom, childBottom);
}
import { KANBAN_GROUP_HEADER_HEIGHT } from './layout.js';
